import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UserActions from '@Actions/userActions';
import Success from '@Images/admin/success.png';
import { Button } from 'antd';
import './style.scss';


/**
 *
 */
function TallySuccess({ history, getUserProfile }) {
  return (
    <div className="integration-success__wrapper">
      <div className="integration-success-action-wrapper__align">
        <img
          src={Success}
          alt="success "
          width="70px"
          height="70px"
          style={{
            marginBottom: '12px',
            marginTop: '10px',
          }}
        />

        <p className="integration-success-heading">Your Tally account is now Connected!</p>
        <p className="integration-success-subheading">Your transactions on Procuzy are now in Sync with your Tally account.</p>

        <div style={{ marginTop: '20px' }}>

          <Button
            type="primary"
            onClick={() => {
              getUserProfile(() => {
                history.push('/admin/integration/tally');
              });
            }}
          >
            Back to Integrations
          </Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = (dispatch) => ({
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),

});
TallySuccess.propTypes = {
  history: PropTypes.any,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallySuccess));
